// series-7 (C.6, #491, 24-sep-2026): EL CUADRO "BUSCAR POR NOMBRE" DE UNA TARJETA PLEGABLE
// ABIERTA (hasta remates-1-3-0c tambien pintaba, si se pedia, el selector de orden).
//
// ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).
//
// Lo usan la tarjeta padre de las partes (solo el cuadro: ahi el orden es fijo por
// numero de parte), la tarjeta del grupo del profe (el cuadro; hasta remates-1-3-0c
// tambien el selector "Mas recientes primero", "A-Z" y "Z-A") y, desde
// ajustes-1-3-0 (Bloque F1, #502), la pantalla de grupos del profe, con su propio
// `placeholder`. Solo existe con la tarjeta ABIERTA, dentro de la guia de adentro: la
// tarjeta plegada no cambia ni un pixel.
//
// El cuadro es el buscador de la casa (el de la ventana de idiomas del Panel: la
// lupa a la izquierda y el campo oscuro con su borde tenue), con la letra de 16 px
// en el telefono (con menos, Safari de iOS acerca la pantalla al tocar el campo; el
// patron del campo de YouTube del Panel) y de 14 desde md. `name="buscar"`. El selector
// no tiene rotulo ratificado: lleva `name="orden"` y sus tres opciones con sus textos
// (C15).
//
// ajustes-1-3-0 (Bloque C4, ajuste 4, 25-sep-2026): EL DISENO DE LA CASA EN LOS TRES
// CUADROS. El cuadro tiene los mismos estilos que el campo de YouTube del Panel (fuente,
// tamano, color, fondo, borde y RADIO en pildora); es `type="text"` con la apariencia nativa
// apagada para que el navegador NO pinte su propia "x", y lleva una "x" PROPIA con el icono
// de la casa a la derecha, solo con texto, que limpia el cuadro y le devuelve el foco (su
// nombre accesible es `common:a11y.close`, el par que la casa ya tiene para una X). El
// selector lleva la apariencia nativa apagada, la flecha `ChevronDown` de la casa a 12 px
// del borde derecho y acolchado a la derecha para que el texto no se encime con ella. Y una
// `ayuda` opcional debajo del cuadro (C3: "Buscando temas..." mientras llegan los temas).
// (Las utilidades no se nombran en esta nota: regla 5.6 de la casa.)
//
// Es CONTROLADO: el valor vive en la tarjeta, que asi lo comparte entre sus dos gemelas
// (movil y escritorio) y lo conserva mientras siga montada.
//
// remates-1-3-0c (Bloque Q7, 26-sep-2026): SE FUE EL SELECTOR DE ORDEN. Carlos: "borra el
// filtro que es de lista; el de la caja de texto no lo borres". La tarjeta del grupo era la
// unica que lo pedia; con el se fueron sus tres opciones (C15, y sus llaves de los dos
// idiomas), la flecha propia y la envoltura que la posicionaba. El orden de la tarjeta del
// grupo queda el de hoy por omision (el del servidor).
import React, { useRef } from 'react';
import { Search, X } from 'lucide-react';
import { Input } from './ui/input';

// La caja: una COLUMNA. El cuadro toma el ancho completo y, si hay `ayuda`, esta va DEBAJO
// del cuadro en todos los anchos. Decia (series-7) una columna en el telefono y un renglon
// desde sm, para poner el selector junto al cuadro; sin selector no hay con quien compartir
// el renglon, y en renglon la ayuda quedaba a la DERECHA del cuadro, no debajo.
export const CAJA_DEL_BUSCADOR = 'flex flex-col gap-2 mb-2';
// El prefijo EXACTO del campo de YouTube del Panel (Dashboard.js), fijado por prueba: la
// pildora (`rounded-full`) es parte de el desde C4.
export const CAMPO_DEL_BUSCADOR = 'bg-[#0a0a0a] border-[#262626] text-white text-base md:text-sm h-10 w-full pl-9 rounded-full';
// remates-1-3-0c (Bloque Q4, W8): UN RENGLON DE 44 PX. La pantalla de grupos del profe pone el
// cuadro junto al boton "Nuevo grupo" (44 px de alto minimo), y la caja medida era de 48 (el
// campo de 40 mas el margen de abajo que la caja trae para las tarjetas plegables). Con
// `alto={44}` el campo mide 44 y la caja no lleva ese margen; sin `alto` (o con otro numero),
// el camino de hoy, byte a byte. Solo esa pantalla lo pide.
export const CAJA_DEL_BUSCADOR_44 = 'flex flex-col gap-2';
export const CAMPO_ALTO_44 = 'h-11';

// t7-3 remate 7 (pasada 3, regla 2 de #581): `tocable44` (solo la tarjeta del grupo del alumno) da 44 de toque sin
// cambiar el dibujo: 2 px de relleno con margen negativo alrededor del campo de 40 (un toque ahi lo enfoca) y un area
// invisible de 44 en la X de 24. Sin la prop, el camino de siempre, byte a byte.
const TOQUE_DEL_CAMPO = { paddingTop: 2, paddingBottom: 2, marginTop: -2, marginBottom: -2 };
const TOQUE_DE_LA_X = { position: 'absolute', top: -10, bottom: -10, left: -10, right: -10 };

export default function BuscadorEnTarjeta({ t, valor, alCambiar, testid, placeholder, ayuda, alto, tocable44 }) {
  const de44 = alto === 44;
  const texto = placeholder || t('dashboard:tarjeta_plegable.buscar');
  const campo = useRef(null);
  const limpiar = () => {
    alCambiar('');
    if (campo.current && typeof campo.current.focus === 'function') campo.current.focus();
  };
  return (
    <div className={de44 ? CAJA_DEL_BUSCADOR_44 : CAJA_DEL_BUSCADOR}>
      <div className="relative flex-1 min-w-0" style={tocable44 ? TOQUE_DEL_CAMPO : undefined}
        onClick={tocable44 ? (e) => { if (e.target === e.currentTarget && campo.current) campo.current.focus(); } : undefined}>
        <Search className="w-4 h-4 text-[#555] absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <Input
          ref={campo}
          type="text"
          name="buscar"
          autoComplete="off"
          value={valor}
          onChange={(e) => alCambiar(e.target.value)}
          placeholder={texto}
          aria-label={texto}
          className={`${CAMPO_DEL_BUSCADOR} appearance-none pr-9${de44 ? ` ${CAMPO_ALTO_44}` : ''}`}
          data-testid={testid}
        />
        {valor ? (
          <button
            type="button"
            onClick={limpiar}
            aria-label={t('common:a11y.close')}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-[#6a6a6a] hoverable:text-white active:text-white active:duration-0"
            data-testid={`${testid}-limpiar`}
          >
            {tocable44 ? <span aria-hidden="true" data-area-tocable="" style={TOQUE_DE_LA_X} /> : null}
            <X className="w-4 h-4" />
          </button>
        ) : null}
      </div>
      {ayuda ? (
        <p className="text-[11px] text-[#a0a0a0] leading-snug" data-testid={`${testid}-ayuda`}>{ayuda}</p>
      ) : null}
    </div>
  );
}
